export default __webpack_public_path__ + "static/media/WF.4ca216d2.svg";